import { API } from "aws-amplify";
import { createBackgroundCheck } from "~/graphql/mutations";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

const EMPTY_BACKGROUND_CHECK: APITypes.BackgroundCheck = {
  id: "",
  status: APITypes.BackgroundCheckStatusType.Pending,
  startDate: "",
  endDate: "",
  __typename: "BackgroundCheck",
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const addBackgroundCheck = async (
  startDate: string
): Promise<LoaderData<APITypes.BackgroundCheck>> => {
  try {
    const newBackgroundCheck = await API.graphql({
      query: createBackgroundCheck,
      variables: {
        input: {
          startDate: startDate,
          status: APITypes.BackgroundCheckStatusType.Pending,
        },
      },
    });
    return {
      success: true,
      //@ts-ignore
      data: newBackgroundCheck.data.createBackgroundCheck,
    };
  } catch (error) {
    console.error("error adding background check", error);
    return {
      success: false,
      data: EMPTY_BACKGROUND_CHECK,
      error,
    };
  }
};
